import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-sidenav-layout',
  templateUrl: './no-sidenav-layout.component.html'
})
export class NoSidenavLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
